import { useMemo } from "react";
import { useTranslation } from "react-i18next";
import WizardStepper from "./WizardStepper";
import "./WizardCreation.css";

export default function WizardHeader({ activeIndex, goToStep }) {
  const { t } = useTranslation();

  const labels = useMemo(
    () => [
      t("wizard.steps.identification"),
      t("wizard.steps.policies"),
      t("wizard.steps.selection"),
      t("wizard.steps.review"),
    ],
    [t],
  );

  return (
    <WizardStepper
      steps={labels}
      activeIndex={activeIndex}
      onBackStepClick={(idx) => {
        if (idx < activeIndex) goToStep(idx);
      }}
    />
  );
}
